import { useSelector } from "react-redux";
import { selectorMainTree, selectorMainTreeBooks } from "./selectors";
import { useMemo } from "react";
import { findNode, getBookIdWithPrefix } from "../../utils/content/content";

export const useSelectFolder = (idFolder) => {
  const folderTree = useSelector(selectorMainTree);
  return useMemo(() => {
    if (idFolder) {
      return findNode(idFolder, folderTree);
    }
    return null;
  }, [idFolder, folderTree]);
};

/**
 * hook for get book by id (book or chapter/paragraph)
 */
export const useSelectorBook = (id) => {
  const bookId = getBookIdWithPrefix(id);

  const books = useSelector(selectorMainTreeBooks);
  const mainTree = useSelector(selectorMainTree);

  const bookFromBooks = useMemo(() => {
    return (books && bookId) ? books.find((book) => book.id === bookId) : undefined;
  }, [books, bookId]);

  return useMemo(() => {
    if (bookFromBooks) {
      const bookOut = bookFromBooks;

      // TODO impl get from bookToc reducer for each book
      const book = findNode(bookId, mainTree);

      if (book.children) {
        bookOut.children = book.children;
        bookOut.chapters = book.chapters;
      }

      return bookOut;
    }

    return undefined;
  }, [bookId, mainTree, bookFromBooks]);
};
